import { Button, Card, Row, Tag, Typography } from 'antd';
import React from 'react';
import { Sender } from '../../../../interfaces/api/Senders';

const { Text } = Typography;

type EmailVerifyCardsProps = {
  emails: Sender[];
  modalVisible: boolean;
  setModalVisible: (modalVisible: boolean) => void;
  onSubmitEmail: (domain: string) => void;
  onRemoveSender: (domain: string) => Promise<void>;
};

const EmailVerifyCards = ({
  emails,
  modalVisible,
  setModalVisible,
  onSubmitEmail,
  onRemoveSender
}: EmailVerifyCardsProps): JSX.Element => {
  return (
    <Card
      style={{ marginTop: '20px' }}
      title="Email Address Verification (Legacy)"
    >
      <Row style={{ marginBottom: '20px' }}>
        <Text>
          Alternatively, you can verify an individual email address. We
          recommend domain verification for production purposes.
        </Text>
      </Row>

      {emails.map((item) => (
        <Row>
          <ul>
            <li>
              {item.sender} <Tag>{item.status}</Tag>
              <Button
                danger
                type="text"
                onClick={(): void => {
                  onRemoveSender(item.sender as string);
                }}
              >
                Remove
              </Button>
            </li>
          </ul>
        </Row>
      ))}
    </Card>
  );
};

export default EmailVerifyCards;
